var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRelatedSr = function SvgRelatedSr(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    viewBox: "0 0 19.4 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M4.545 17.608a7.9 7.9 0 0 0 4.89 1.69 7.88 7.88 0 0 0 4.891-1.69M7.107 3.81a7.92 7.92 0 0 0-5.165 10.131m9.823-10.131a7.92 7.92 0 0 1 5.165 10.131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M18.676 16.246c0 .652-.25 1.244-.657 1.68a2.316 2.316 0 0 1-2.99.362 2.42 2.42 0 0 1-.972-1.305 2.5 2.5 0 0 1 .058-1.641c.205-.524.58-.958 1.063-1.228a2.3 2.3 0 0 1 1.58-.253c.54.107 1.027.404 1.376.84.35.434.541.98.541 1.545m-13.245 0c0 .652-.25 1.244-.657 1.68a2.316 2.316 0 0 1-2.99.362 2.42 2.42 0 0 1-.972-1.305 2.5 2.5 0 0 1 .058-1.641c.205-.524.58-.958 1.063-1.228a2.3 2.3 0 0 1 1.58-.253c.54.107 1.027.404 1.376.84.35.434.541.98.542 1.545M12.053 3.13c0 .652-.25 1.244-.657 1.68a2.316 2.316 0 0 1-2.99.362 2.42 2.42 0 0 1-.972-1.305 2.5 2.5 0 0 1 .059-1.642c.205-.523.58-.957 1.063-1.227a2.3 2.3 0 0 1 1.58-.253c.54.107 1.026.404 1.376.839s.54.982.541 1.546"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRelatedSr);
export default ForwardRef;